import {observer} from "mobx-react-lite";
import {Fragment} from "react";
import {DownloadOutlined} from "@ant-design/icons";
import {
    Button,
    Checkbox,
    ConfigProvider,
    Empty,
    Form,
    Input,
    Modal,
    Row,
    Select,
    Space,
    Table,
    Upload,
    UploadProps,
    message,
} from "antd";
import {MyApplicationStore} from "../../../../store";
import {UploadOutlined} from "@ant-design/icons";
import {Col} from "antd/lib";

const {Column} = Table;
const CheckboxGroup = Checkbox.Group;

function TemplatePreview(props: any) {
    const form = Form.useFormInstance();
    const {Option} = Select;

    const getFormData = (
        changeValue: powerSearchData,
        allValues: powerSearchData
    ) => {
        MyApplicationStore.setSearchModalForm({...allValues});
    };

    const searchBtn = () => {
        MyApplicationStore.resetPage();
        MyApplicationStore.previewPage();
    };

    const resetSearchbth = () => {
        delete MyApplicationStore.searchFormModal.errorType
        delete MyApplicationStore.searchFormModal.phoneNumber
        delete MyApplicationStore.searchFormModal.verifyResult
        searchBtn();
    };

    const submitPower = () => {
        MyApplicationStore.submitAddNumber(MyApplicationStore.formData);
    };

    const updateProps: UploadProps = {
        beforeUpload(info) {
            if (info.type !== "application/pdf") {
                message.error("请上传PDF格式");
                return Upload.LIST_IGNORE
            } else {
                return false
            }
        },
        onChange: (info) => {
            if (info.file && info.file.type === "application/pdf" && info.fileList.length > 0) {
                MyApplicationStore.formData = info;
                MyApplicationStore.approval = true;
                message.success("上传成功");
            } else {
                MyApplicationStore.formData = null;
                MyApplicationStore.approval = false
            }
        },
    };
    const tableEmptyRender = () => {
        return (
            <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={<>暂无数据</>}
            ></Empty>
        );
    };
    return (
        <Fragment>
            <Modal
                width={"80%"}
                title={"新增预览"}
                open={MyApplicationStore.templateModal}
                destroyOnClose={true}
                centered
                // className="previewModal"
                onCancel={() => MyApplicationStore.cancelPreview()}
                footer={[
                    <Button key="back" onClick={() => MyApplicationStore.cancelPreview()}>
                        取消
                    </Button>,
                    <Button
                        disabled={
                            MyApplicationStore.approval ? MyApplicationStore.allowSubmit : true}
                        key="submit"
                        type="primary"
                        onClick={submitPower}
                        loading={MyApplicationStore.buttonLoading}
                    >
                        提交
                    </Button>,
                ]}
            >
                <Form
                    form={form}
                    initialValues={MyApplicationStore.searchFormModal}
                    autoComplete="off"
                    layout="inline"
                    className="formSty"
                    onValuesChange={getFormData}
                >
                    <Row>
                        <Col span={24}>
                            <Form.Item
                                label="请上传附件："
                                name="upload"
                                rules={[{required: true, message: "请上传PDF格式"}]}
                                style={{
                                    width: "500px",
                                    marginBottom: "15px",
                                    marginLeft: "10px",
                                }}
                                valuePropName="fileList"
                                getValueFromEvent={(e) => {
                                    if (Array.isArray(e)) {
                                        return e;
                                    }
                                    return e && e.fileList;
                                }}
                            >
                                <Upload name="text" {...updateProps} maxCount={1}>
                                    <Button icon={<UploadOutlined/>}>上传号码报备书</Button>
                                </Upload>
                            </Form.Item>
                        </Col>
                        <Col>
                            <Form.Item
                                label="号码"
                                name="phoneNumber"
                                style={{
                                    width: "266px",
                                    marginBottom: "10px",
                                    marginLeft: "10px",
                                }}
                            >
                                <Input placeholder="请输入号码"/>
                            </Form.Item>
                        </Col>
                        <Col>
                            <Form.Item
                                label="校验状态"
                                name="verifyResult"
                                style={{
                                    width: "266px",
                                    marginBottom: "10px",
                                    marginLeft: "10px",
                                }}
                            >
                                <Select placeholder="请选择">
                                    <Option value={true}>是</Option>
                                    <Option value={false}>否</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col>
                            <Form.Item
                                label="错误类型"
                                name="errorType"
                                style={{
                                    width: "266px",
                                    marginBottom: "10px",
                                    marginLeft: "10px",
                                }}
                            >
                                <Select placeholder="请选择">
                                    <Option value={"池内重复"}>池内重复</Option>
                                    <Option value={"表内重复"}>表内重复</Option>
                                    <Option value={"其他错误"}>其他错误</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col>
                            <Form.Item style={{marginBottom: "10px", marginLeft: "10px"}}>
                                <Space>
                                    <Button type="primary" onClick={searchBtn}>
                                        搜索
                                    </Button>
                                    <Button htmlType="reset" onClick={resetSearchbth}>
                                        重置
                                    </Button>
                                </Space>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                {MyApplicationStore.exportErrorFlag && (
                    <DownloadOutlined
                        className="outLineIcon"
                        onClick={() => MyApplicationStore.exportError()}
                    />
                )}
                <ConfigProvider renderEmpty={tableEmptyRender}>
                    <Table
                        dataSource={MyApplicationStore.tableDataModal.records}
                        rowKey={(record: any) => record.id}
                        loading={MyApplicationStore.tableLoad}
                        scroll={{x: 1000}}
                        className="tableSty"
                        pagination={{
                            current: MyApplicationStore.pageDataModal.page,
                            pageSize: MyApplicationStore.pageDataModal.size,
                            onChange: MyApplicationStore.pageDataModal.changePage,
                            pageSizeOptions: [10, 15, 20, 25],
                            showSizeChanger: true,
                            total: MyApplicationStore.tableDataModal.total,
                            showTotal: () => `共计${MyApplicationStore.tableDataModal.total}条`,
                            position: ["bottomLeft"],
                        }}
                    >
                        <Column ellipsis={true} title="号码" dataIndex="phoneNumber"/>
                        <Column ellipsis={true} title="号码类型" dataIndex="type"/>
                        <Column ellipsis={true} title="所属X池编号" dataIndex="portalXpoolNo"/>
                        <Column title="平台编码" dataIndex="targetPlatform"/>
                        <Column
                            title="虚拟运营商ID"
                            dataIndex="virtualCarrierId"
                        />
                        <Column title="基础运营商" dataIndex="infraCarrier"/>
                        <Column title="号码所属区号" dataIndex="areaCode"/>
                        <Column title="号码所属省份" dataIndex="provinceName"/>
                        <Column title="号码所属城市" dataIndex="cityName"/>
                        <Column title="备注" dataIndex="remark"/>
                        <Column
                            title="校验状态"
                            dataIndex="verifyResult"
                            render={(status) => (status ? "是" : "否")}
                        />
                        <Column title="错误类型" dataIndex="errorType"/>
                        <Column title="错误原因" dataIndex="errorMsg"/>
                    </Table></ConfigProvider>
                <CheckboxGroup
                    value={MyApplicationStore.checkedList}
                    onChange={(list) => MyApplicationStore.changeCheckList(list)}
                >
                    <Checkbox value={"poolRepeat"}>
                        忽略池内重复（{MyApplicationStore.previewCountData.poolRepeat}）
                    </Checkbox>
                    <Checkbox value={"tableRepeat"}>
                        忽略表内重复（{MyApplicationStore.previewCountData.tableRepeat}）
                    </Checkbox>
                    <Checkbox value={"otherError"}>
                        忽略其他错误（{MyApplicationStore.previewCountData.otherError}）
                    </Checkbox>
                </CheckboxGroup>
            </Modal>
        </Fragment>
    );
}

export default observer(TemplatePreview);
